import { render } from "./Contact.vue?vue&type=template&id=44260d9b"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=44260d9b&rel=stylesheet&lang=scss"
script.render = render

export default script